import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { FlagIconList } from './flags';
import type { App } from 'vue';

/* import specific icons */
import {
    faHome,
    faUsers,
    faMoon,
    faCalendarLinesPen,
    faCalendar,
    faUserCheck,
    faShapes,
    faScroll,
    faUser,
    faSpinnerThird,
    faCheck,
    faBars,
    faUpToLine,
    faDownFromLine,
    faLeftToLine,
    faRightFromLine,
    faFilePen,
    faScrewdriverWrench,
    faFloppyDisk,
    faArrowsRotate,
    faTrashXmark,
    faGrid2Plus,
    faPeopleGroup,
    faXmark,
    faArrowRight,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
    faSquareExclamation,
    faFlagCheckered,
    faSunBright,
    faCloudsMoon,
    faPenField,
    faBullhorn,
    faSquareArrowUpRight,
    faCircleQuestion,
    faCircleExclamation,
    faRightFromBracket,
    faBell,
    faCommentsQuestionCheck,
    faGrid,
    faList,
    faGripLines,
    faPenToSquare,
    faLayerGroup,
    faCube,
    faCubes,
    faCircle,
    faSquareA,
    faSquareB,
    faSquareC,
    faSquareD,
    faMagnifyingGlass,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus,
    faBarsFilter,
    faSquare,
    faLineColumns,
    faWindowMaximize,
    faWindowMinimize,
    faFileImport,
    faCloudArrowUp,
    faCloudArrowDown,
    faMars,
    faVenus,
    faClock,
    faGear,
    faTriangleExclamation,
    faCircleXmark,
    faStopwatch,
    faHashtag,
    faChartLine,
    faGlobe,
    faTable,
    faPencil,
    faPlus,
    faCircleInfo,
    faFileVector,
    faHatWizard,
    faWandSparkles,
    faCalendarCheck,
    faCalendarClock,
    faCircleCheck,
    faTicketPerforated,
    faPaperPlaneTop,
    faFilter,
    faGaugeCircleMinus,
    faDown,
    faUp,
    faEye,
    faPercent,
    faMemoCircleInfo,
    faSquareCheck,
    faWandMagicSparkles,
    faCirclePlus,
    faRectangleHistoryCirclePlus,
    faPersonCirclePlus,
    faSquareDashedCirclePlus,
    faPalette,
    faText,
    faFolderImage,
    faSwatchbook,
    faRotateRight,
    faPencilPaintbrush,
    faSparkle,
    faMapLocationDot,
    faMap,
    faEllipsisVertical,
    faLocationArrow,
    faMapPin,
    faBookmark,
    faSatellite,
    faSignalStream,
    faSignalStreamSlash,
    faSignal,
    faSignalSlash,
    faWavePulse,
    faCircleNodes,
    faListTree,
    faCircleMinus,
    faEyeSlash,
    faSquareQuestion,
    faTachographDigital,
    faBellSlash,
    faArrowsMaximize,
    faArrowDownLeftAndArrowUpRightToCenter,
    faArrowUpRightFromSquare,
    faSquarePlus,
    faGauge,
    faGaugeLow,
    faGaugeHigh,
    faEngine,
    faBinRecycle,
    faShuffle,
    faObjectGroup,
    faObjectUnion,
    faGun,
    faThumbTack,
    faThumbTackSlash,
    faCircleStar,
    faArrowsLeftRightToLine,
    faLightbulb,
    faLightbulbOn,
    faLightbulbSlash,
    faMagnifyingGlassChart,
    faCompassSlash,
    faGaugeMin,
    faListOl,
    faObjectIntersect,
    faMerge,
    faPeopleArrows,
    faDisplay,
    faTableList,
    faTableColumns,
    faScreencast,
    faCircleWifi,
    faIdBadge,
    faUserPen,
    faAt,
    faPhone,
    faUserLock,
    faUserUnlock,
    faUserMagnifyingGlass,
    faLock,
    faLockOpen,
    faCopy,
    faTowerControl,
    faPrint,
    faBadge,
    faBadgeCheck,
    faArrowTurnDownRight,
    faGripDotsVertical,
    faCrosshairsSimple,
    faGlobePointer,
    faUsersMedical,
    faCaretRight,
    faCaretDown,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faUsersBetweenLines,
    faEnvelopeCircleCheck,
    faFiles,
    faEnvelopesBulk,
    faTags,
    faTag,
    faMinus,
    faClockRotateLeft,
    faLinkSimple,
    faCode,
    faUserPlus,
    faGameBoard,
    faSliders,
    faAddressCard,
    faCompass,
    faSitemap,
    faQuestion,
    faFile,
    faFileArrowDown,
    faFileImage,
    faFileAudio,
    faFileVideo,
    faFileWord,
    faFileExcel,
    faFilePowerpoint,
    faFileText,
    faFileCode,
    faFileArchive,
    faFilePng,
    faFileJpg,
    faFileGif,
    faFilePdf,
    faFileSvg,
    faFileCsv,
    faFileXml,
    faFolder,
    faFolders,
    faFolderArrowUp,
    faBolt,
    faArrowDownWideShort,
    faKeyboard,
    faPuzzle,
    faPuzzlePieceSimple,
    faPuzzlePieceAlt,
    faPuzzlePiece,
    faRankingStar,
    faPlay,
    faBullseye,
    faRepeat,
    faShirt,
    faArrowRightArrowLeft,
    faForwardStep,
    faVrCardboard,
    faCamera,
    faRotateReverse,
    faEraser,
    faTrashCan,
    faMemo,
    faStar,
    faAward,
    faPencilMechanical,
    faWind,
    faDroplet,
    faSnowflake,
    faSnowflakeDroplets,
    faNote,
    faIdCard,
} from '@fortawesome/pro-light-svg-icons';

import {
    faX,
    faCircle as faCircleSolid,
    faTags as faTagsSolid,
    faTag as faTagSolid,
    faPlug,
    faSortUp,
    faSortDown,
    faSort,
    faGear as faGearSolid,
    faCircleCheck as faCircleCheckSolid,
    faCircleXmark as faCircleXmarkSolid,
    faXmark as faXmarkSolid,
    faPersonRunningFast,
    faPersonWalkingDashedLineArrowRight,
    faCircleExclamation as faCircleExclamationSolid,
    faExclamation as faExclamationSolid,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faBatteryFull,
    faBatteryHalf,
    faBatteryThreeQuarters,
    faBatteryLow,
    faBatteryExclamation,
    faBatteryEmpty,
    faBatteryBolt,
    faBatterySlash,
    faBan,
    faStopwatch as faStopwatchDisabled,
} from '@fortawesome/pro-duotone-svg-icons';

import { faGoogle, faMicrosoft, faWindows, faApple, faAndroid, faLinux, faWikipediaW } from '@fortawesome/free-brands-svg-icons';

export default function InitIcons(app: App<Element>) {
    /* add icons to the library */
    add(faHome);
    add(faUsers);
    add(faCalendarLinesPen);
    add(faUserCheck);
    add(faShapes);
    add(faUser);
    add(faScroll);
    add(faSpinnerThird);
    add(faCheck);
    add(faBars);
    add(faUpToLine);
    add(faDownFromLine);
    add(faLeftToLine);
    add(faRightFromLine);
    add(faFilePen);
    add(faScrewdriverWrench);
    add(faFloppyDisk);
    add(faArrowsRotate);
    add(faTrashXmark);
    add(faGrid2Plus);
    add(faPeopleGroup);
    add(faXmark);
    add(faArrowRight);
    add(faArrowLeft);
    add(faSquareExclamation);
    add(faFlagCheckered);
    add(faSunBright);
    add(faCloudsMoon);
    add(faPenField);
    add(faBullhorn);
    add(faSquareArrowUpRight);
    add(faCalendar);
    add(faMoon);
    add(faCircleQuestion);
    add(faRightFromBracket);
    add(faBell);
    add(faCommentsQuestionCheck);
    add(faCircleExclamation);
    add(faGrid);
    add(faList);
    add(faX);
    add(faGripLines);
    add(faPenToSquare);
    add(faLayerGroup);
    add(faCube);
    add(faCubes);
    add(faBatteryFull);
    add(faBatteryHalf);
    add(faBatteryThreeQuarters);
    add(faBatteryLow);
    add(faBatteryEmpty);
    add(faBatteryExclamation);
    add(faBatteryBolt);
    add(faCircle);
    add(faCircleSolid);
    add(faPlug);
    add(faSquareA);
    add(faSquareB);
    add(faSquareC);
    add(faSquareD);
    add(faSquare);
    add(faMagnifyingGlass);
    add(faBarsFilter);
    add(faLineColumns);
    add(faWindowMaximize);
    add(faWindowMinimize);
    add(faFileImport);
    add(faCloudArrowUp);
    add(faMars);
    add(faVenus);
    add(faClock);
    add(faGear);
    add(faTriangleExclamation);
    add(faCircleXmark);
    add(faStopwatch);
    add(faHashtag);
    add(faChartLine);
    add(faGlobe);
    add(faTable);
    add(faPencil);
    add(faPlus);
    add(faSortUp);
    add(faSortDown);
    add(faSort);
    add(faFileVector);
    add(faCircleInfo);
    add(faHatWizard);
    add(faCalendarCheck);
    add(faCircleCheck);
    add(faTicketPerforated);
    add(faPaperPlaneTop);
    add(faFilter);
    add(faGaugeCircleMinus);
    add(faDown);
    add(faUp);
    add(faGoogle);
    add(faEye);
    add(faWikipediaW);
    add(faMemoCircleInfo);
    add(faSquareCheck);
    add(faWandMagicSparkles);
    add(faCirclePlus);
    add(faRectangleHistoryCirclePlus);
    add(faPersonCirclePlus);
    add(faSquareDashedCirclePlus);
    add(faPercent);
    add(faWandSparkles);
    add(faPalette);
    add(faText);
    add(faFolderImage);
    add(faSwatchbook);
    add(faRotateRight);
    add(faPencilPaintbrush);
    add(faMagnifyingGlassPlus);
    add(faMagnifyingGlassMinus);
    add(faSparkle);
    add(faMapLocationDot);
    add(faMap);
    add(faEllipsisVertical);
    add(faLocationArrow);
    add(faMapPin);
    add(faBookmark);
    add(faSatellite);
    add(faSignalStream);
    add(faSignalStreamSlash);
    add(faBatterySlash);
    add(faSignal);
    add(faSignalSlash);
    add(faWavePulse);
    add(faCircleNodes);
    add(faListTree);
    add(faCircleMinus);
    add(faEyeSlash);
    add(faSquareQuestion);
    add(faTachographDigital);
    add(faBellSlash);
    add(faArrowsMaximize);
    add(faArrowDownLeftAndArrowUpRightToCenter);
    add(faArrowUpRightFromSquare);
    add(faSquarePlus);
    add(faGauge);
    add(faGaugeLow);
    add(faGaugeHigh);
    add(faEngine);
    add(faBinRecycle);
    add(faShuffle);
    add(faObjectGroup);
    add(faObjectUnion);
    add(faGun);
    add(faThumbTack);
    add(faThumbTackSlash);
    add(faCircleStar);
    add(faArrowsLeftRightToLine);
    add(faLightbulb);
    add(faLightbulbOn);
    add(faLightbulbSlash);
    add(faCircleStar);
    add(faMagnifyingGlassChart);
    add(faSquareQuestion);
    add(faCompassSlash);
    add(faGaugeMin);
    add(faDisplay);
    add(faLinux);
    add(faWindows);
    add(faMicrosoft);
    add(faApple);
    add(faAndroid);
    add(faTableList);
    add(faTableColumns);
    add(faScreencast);
    add(faCircleWifi);
    add(faListOl);
    add(faObjectIntersect);
    add(faMerge);
    add(faPeopleArrows);
    add(faIdBadge);
    add(faPersonRunningFast);
    add(faPersonWalkingDashedLineArrowRight);
    add(faUserPen);
    add(faAt);
    add(faPhone);
    add(faUserLock);
    add(faUserUnlock);
    add(faUserMagnifyingGlass);
    add(faLock);
    add(faLockOpen);
    add(faCopy);
    add(faStopwatchDisabled);
    add(faTowerControl);
    add(faPrint);
    add(faBadge);
    add(faBadgeCheck);
    add(faBan);
    add(faArrowTurnDownRight);
    add(faGripDotsVertical);
    add(faCrosshairsSimple);
    add(faPlay);
    add(faGlobePointer);
    add(faUsersMedical);
    add(faCaretRight);
    add(faCaretDown);
    add(faChevronRight);
    add(faChevronDown);
    add(faChevronUp);
    add(faUsersBetweenLines);
    add(faEnvelopeCircleCheck);
    add(faFiles);
    add(faEnvelopesBulk);
    add(faTags);
    add(faTag);
    add(faCloudArrowDown);
    add(faMinus);
    add(faClockRotateLeft);
    add(faLinkSimple);
    add(faCode);
    add(faUserPlus);
    add(faGameBoard);
    add(faSliders);
    add(faAddressCard);
    add(faCompass);
    add(faSitemap);
    add(faQuestion);
    add(faFileArrowDown);
    add(faFileImage);
    add(faFileAudio);
    add(faFileVideo);
    add(faFilePdf);
    add(faFileWord);
    add(faFileExcel);
    add(faFilePowerpoint);
    add(faFileText);
    add(faFileCode);
    add(faFileArchive);
    add(faFile);
    add(faFilePng);
    add(faFileJpg);
    add(faFileGif);
    add(faFileSvg);
    add(faFileCsv);
    add(faFileXml);
    add(faFolder);
    add(faFolders);
    add(faFolderArrowUp);
    add(faBolt);
    add(faArrowDownWideShort);
    add(faKeyboard);
    add(faPuzzle);
    add(faPuzzlePieceSimple);
    add(faPuzzlePieceAlt);
    add(faPuzzlePiece);
    add(faRankingStar);
    add(faBullseye);
    add(faRepeat);
    add(faShirt);
    add(faArrowRightArrowLeft);
    add(faForwardStep);
    add(faVrCardboard);
    add(faGearSolid);
    add(faCamera);
    add(faRotateReverse);
    add(faCircleCheckSolid);
    add(faTagSolid);
    add(faTagsSolid);
    add(faEraser);
    add(faTrashCan);
    add(faXmarkSolid);
    add(faCircleXmarkSolid);
    add(faMemo);
    add(faStar);
    add(faAward);
    add(faPencilMechanical);
    add(faCalendarClock);
    add(faWind);
    add(faArrowDown);
    add(faArrowUp);
    add(faDroplet);
    add(faSnowflake);
    add(faSnowflakeDroplets);
    add(faNote);
    add(faIdCard);

    add(faCircleExclamationSolid);
    add(faExclamationSolid);
    app.component('font-awesome-icon', FontAwesomeIcon);
}

const add = (icon: IconDefinition) => {
    library.add(icon);
    IconList.push({ name: 'fa-' + icon.iconName, prefix: icon.prefix });
};

export const IconList: Array<{ name: string; prefix: string }> = FlagIconList;

export type IconName = (typeof IconList)[number]['name'];
